<template>
    <div>
        <div class="mb-2">Pass {{ latestScore.num }}</div>
        <v-simple-table v-if="$vuetify.breakpoint.smAndUp">
            <thead>
                <tr>
                    <th>Execution</th>
                    <th>DD</th>
                    <th>ND</th>
                    <th>Score</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ $score(latestScore.execution, '0.000') }}</td>
                    <td>{{ $score(latestScore.dd, '0.0') }}</td>
                    <td>{{ $score(latestScore.nd, '0.0') }}</td>
                    <td>{{ $score(latestScore.total, '0.000') }}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import Result from '@/Models/Result.js';

export default {
    name: 'TumblingHighlight',

    props: {
        result: {
            type: Result,
            required: true,
        },
    },

    data: () => ({}),

    computed: {
        latestScore() {
            return this.result.latest_score;
        },
    },
};
</script>

<style lang="scss" scoped>
th,
td {
    font-size: 1.2rem;
    text-align: left;
    padding: 0 !important;
}

td {
    font-size: 1rem;
}
</style>
